import React from 'react';
import { Box, Typography } from '@mui/material';
import { BuyingPowerEstimate } from '../../../utils/buyerBrokerFee';
import { LD, formatCurrency } from './tokens';

interface BuyingPowerCardProps {
  estimate: BuyingPowerEstimate;
  onHowItWorks: () => void;
}

/**
 * The phone's one buying-power card: the figure the sticky button offers,
 * and in the same place, where it comes from.
 */
const BuyingPowerCard: React.FC<BuyingPowerCardProps> = ({
  estimate,
  onHowItWorks,
}) => {
  const fee = estimate.feeIsMinimum
    ? `${formatCurrency(estimate.homepointFee)} (the minimum)`
    : formatCurrency(estimate.homepointFee);

  return (
    <Box
      data-testid="mobile-buying-power-card"
      sx={{
        mt: '12px',
        display: 'flex',
        gap: '12px',
        alignItems: 'center',
        bgcolor: LD.greenTint,
        border: `1px solid ${LD.greenLine}`,
        borderRadius: '12px',
        px: '14px',
        py: '12px',
      }}
    >
      <Box sx={{ flexShrink: 0 }}>
        <Typography
          data-testid="buying-power-amount"
          sx={{
            fontSize: '24px',
            fontWeight: 800,
            color: LD.green,
            lineHeight: 'normal',
          }}
        >
          {formatCurrency(estimate.buyingPower)}
        </Typography>
        <Typography
          sx={{
            fontSize: '12.5px',
            color: LD.ink2,
            fontWeight: 600,
            lineHeight: 'normal',
          }}
        >
          more buying
          <br />
          power
        </Typography>
      </Box>
      <Typography
        component="div"
        sx={{
          fontSize: '12.5px',
          color: LD.ink2,
          lineHeight: 1.45,
          borderLeft: `1px solid ${LD.greenLine}`,
          pl: '12px',
        }}
      >
        Homepoint fee {fee} vs {formatCurrency(estimate.typicalCommission)} at a
        typical 3%. Use the difference to negotiate.{' '}
        <Box
          component="button"
          type="button"
          onClick={onHowItWorks}
          sx={{
            p: 0,
            border: 0,
            bgcolor: 'transparent',
            font: 'inherit',
            color: LD.primary,
            fontWeight: 700,
            cursor: 'pointer',
          }}
        >
          How it works ›
        </Box>
      </Typography>
    </Box>
  );
};

export default BuyingPowerCard;
